/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Started_ToastInputs */



/**
* | output |
* | --- |
* | "Starting OCR analysis..." |
*
* @param {Ocr_Started_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_started_toast = /** @type {((inputs?: Ocr_Started_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Started_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Début de l'analyse OCR...")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Analyse wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'analisi OCR...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало анализа OCR...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando el análisis OCR...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始OCR分析……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCR分析を開始します...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर विश्लेषण शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a análise de OCR...")
	return /** @type {LocalizedString} */ ("Starting OCR analysis...")
});